import Home from '../components/Home.vue';
import Gyms from '../components/Gyms.vue';
import About from '../components/About.vue';
import SignIn from '../components/SignIn.vue';
import SignUp from '../components/SignUp.vue';
import Error404 from '../components/Error404.vue';
import User from '../components/User.vue';
import Prices from '../components/Prices.vue';
import AddClass from '../components/AddClass.vue';
import Classes_overview from '../components/Classes_overview.vue';
import ExploreWorkouts from '../components/ExploreWorkouts.vue';
import Order from '../components/Order.vue';
import Charge from '../components/Charge.vue';
import Complete from '../components/Complete.vue';
import Admin from '../components/Admin.vue';
import StudioAdmin from '../components/StudioAdmin.vue';

// This is where you add all your site routes
// Each route is set as an obect in the array
// For a the most basic route just set
// the path & component to load

export const routes = [
  { path: '', name: 'home', component: Home },
  { path: '/sign-in', name: 'signIn', component: SignIn },
  { path: '/sign-up', name: 'signUp', component: SignUp },
  { path: '/prices', name: 'prices', component: Prices },
  { path: '/user', name: 'user', component: User, meta: { requiresAuth: true }},
  { path: '/gyms', name: 'gyms', component: Gyms },
  { path: '/about', name: 'about', component: About },
  { path: '/addclass', name: 'addclass', component: AddClass },
  { path: '/classesoverview', name: 'classesoverview', component: Classes_overview },
  { path: '/order', name: 'order', component: Order },
  { path: '/charge', name: 'charge', component: Charge },
  { name: '/order-complete', path: '/order-complete/:id', component: Complete },
  { path: '/explore', name: 'explore', component: ExploreWorkouts },
  { path: '/admin', name: 'admin', component: Admin },
  { path: '/404', name: '404', component: Error404 },
  { path: '/studioadmin', name: 'studioadmin', component: StudioAdmin },
  { path: '*', redirect: '/404' }
]



// WEBPACK FOOTER //
// ./src/router/routes.js